import { render, staticRenderFns } from "./MyFirstDataEditor.vue?vue&type=template&id=d1483ba2&scoped=true"
import script from "./MyFirstDataEditor.vue?vue&type=script&lang=js"
export * from "./MyFirstDataEditor.vue?vue&type=script&lang=js"
import style0 from "./MyFirstDataEditor.vue?vue&type=style&index=0&id=d1483ba2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1483ba2",
  null
  
)

export default component.exports